module.exports.strings = require('./strings')
